@let s = status();
<section class="rm-doc__sec">
  <h3 class="rm-doc__sec-title">
    <span class="rm-doc__nr">1</span>
    {{ 'testResults.report.doc.status.stand' | translate }}
  </h3>
  <div data-testid="report-status-stand">
    {{ 'testResults.report.doc.status.period' | translate: { zeitraum: s.zeitraumText } }}
    · {{ 'testResults.report.doc.status.scope' | translate: { scope: scopeLabel() } }} ·
    @if (s.teststufe) {
      {{ 'testResults.report.doc.status.stage' | translate: { stufe: s.teststufe } }} ·
    }
    {{ 'testResults.report.doc.status.candidate' | translate }}
  </div>
</section>
<section class="rm-doc__sec">
  <h3 class="rm-doc__sec-title">
    <span class="rm-doc__nr">2</span>
    {{ 'testResults.report.doc.status.progress' | translate }}
  </h3>
  <div class="rm-sum__tiles">
    <div class="rm-tile" data-tile="ausgefuehrt">
      <div class="rm-tile__label">{{ 'testResults.report.summary.executed' | translate }}</div>
      <div class="rm-tile__value">{{ s.ausgefuehrt }}/{{ s.gesamt }}</div>
      <div class="rm-tile__sub">{{ progress(s.ausgefuehrt, s.gesamt) }} %</div>
    </div>
    <div class="rm-tile" data-tile="passrate">
      <div class="rm-tile__label">{{ 'testResults.report.summary.passRate' | translate }}</div>
      <div class="rm-tile__value">{{ s.ausgefuehrt === 0 ? '—' : s.passRate + '%' }}</div>
      <div class="rm-tile__sub">{{ 'testResults.report.doc.status.ofExecuted' | translate }}</div>
    </div>
    <div class="rm-tile rm-tile--failed" data-tile="failed">
      <div class="rm-tile__label">{{ 'testResults.report.doc.status.deviating' | translate }}</div>
      <div class="rm-tile__value">{{ s.failed }}</div>
    </div>
    <div class="rm-tile rm-tile--blocked" data-tile="blocked">
      <div class="rm-tile__label">{{ 'testResults.report.summary.blocked' | translate }}</div>
      <div class="rm-tile__value">{{ s.blocked }}</div>
    </div>
  </div>
  <p class="rm-doc__note" data-testid="report-status-period-count">
    {{ 'testResults.report.doc.status.periodCount' | translate: { count: s.imZeitraumAusgefuehrt } }}
  </p>
  @for (p of s.fortschrittJePlan; track p.planId) {
    <div class="rm-progress" data-testid="report-status-plan">
      <span class="rm-progress__name">
        <code class="rm-code">{{ p.planKey }}</code>
        {{ p.titel }}
      </span>
      <span class="rm-progress__track" aria-hidden="true">
        <span class="rm-progress__fill" [style.width.%]="planProgress(p)"></span>
      </span>
      <span class="rm-progress__value">
        {{ 'testResults.report.doc.status.planValue' | translate: { ist: planProgress(p) } }}
      </span>
    </div>
  }
</section>
<section class="rm-doc__sec">
  <h3 class="rm-doc__sec-title">
    <span class="rm-doc__nr">3</span>
    {{ 'testResults.report.doc.status.blocker' | translate }}
  </h3>
  @if (s.blocker.length > 0) {
    <table class="rm-table">
      <thead>
        <tr>
          <th scope="col">{{ 'testResults.report.trace.testCase' | translate }}</th>
          <th scope="col">{{ 'testResults.report.doc.title' | translate }}</th>
          <th scope="col">{{ 'testResults.report.doc.plan' | translate }}</th>
          <th scope="col">{{ 'testResults.report.doc.status.cause' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (b of s.blocker; track b.planId + b.testCaseId) {
          <tr data-testid="report-status-blocker">
            <td>
              <code class="rm-code">{{ b.testCaseKey }}</code>
            </td>
            <td>{{ b.titel }}</td>
            <td>{{ blockerPlans(b) }}</td>
            <td>
              {{ b.bugKey ? ('testResults.report.doc.status.bug' | translate: { key: b.bugKey }) : '—' }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <p class="rm-doc__note" data-testid="report-status-no-blocker">
      {{ 'testResults.report.doc.status.noBlocker' | translate }}
    </p>
  }
</section>
<section class="rm-doc__sec">
  <h3 class="rm-doc__sec-title">
    <span class="rm-doc__nr">4</span>
    {{ 'testResults.report.doc.status.risks' | translate }}
  </h3>
  <div data-testid="report-status-open">—</div>
</section>
<section class="rm-doc__sec">
  <h3 class="rm-doc__sec-title">
    <span class="rm-doc__nr">5</span>
    {{ 'testResults.report.doc.status.planned' | translate }}
  </h3>
  <div data-testid="report-status-open">—</div>
</section>
